// extracted by mini-css-extract-plugin
module.exports = {"CompanyHeader":"_1tg1nPF1","headerLogoContainer":"_1q2vZ547","headerDetailsContainer":"_1q5YOyoy","headerName":"_1dkiC5mh","headerIndustry":"_2BkC3t1K","headerTagline":"_1pR7YjxR","headerDeets":"_3G262DKd","headerDetailContainer":"_3QdDvjtb","headerDetail":"_2wyfWTI-","headerDetailBull":"WVSA_RkQ","headerLink":"q__24nn_","sizeMax":"_1yml7l3a"};
    if(module.hot) {
      // 1754514992173
      var cssReload = require("!../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  